function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import i18n from '@/utils/i18n';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import refMixinDesign from '@/components/form-designer/refMixinDesign';
import containerMixin from '@/components/form-designer/form-widget/container-widget/containerMixin';
export default {
  name: 'GridColWidget',
  componentName: 'GridColWidget',
  mixins: [i18n, refMixinDesign, containerMixin],
  inject: ['refList'],
  components: _objectSpread({
    Draggable: Draggable
  }, FieldComponents),
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
    colHeight: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      layoutProps: {
        span: Number(this.widget.options.span) || 12,
        // 样式错误注释下三行
        md: Number(this.widget.options.md) || 12,
        sm: Number(this.widget.options.sm) || 12,
        xs: Number(this.widget.options.xs) || 12,
        offset: Number(this.widget.options.offset) || 0,
        push: Number(this.widget.options.push) || 0,
        pull: Number(this.widget.options.pull) || 0
      }
    };
  },
  computed: {
    selected: function selected() {
      return this.widget.id === this.designer.selectedId;
    },
    customClass: function customClass() {
      return this.widget.options.customClass || '';
    },
    colHeightStyle: function colHeightStyle() {
      return !!this.colHeight ? {
        height: this.colHeight + 'px'
      } : {};
    }
  },
  watch: {
    'designer.formConfig.layoutType': {
      handler: function handler(val) {
        if (!!this.widget.options.responsive) {
          if (val === 'H5') {
            this.layoutProps.span = Number(this.widget.options.xs) || 12;
          } else if (val === 'Pad') {
            this.layoutProps.span = Number(this.widget.options.sm) || 12;
          } else {
            this.layoutProps.span = Number(this.widget.options.md) || 12;
          }
        } else {
          this.layoutProps.span = Number(this.widget.options.span) || 12;
        }
      }
    },
    'widget.options.responsive': {
      handler: function handler(val) {
        var lyType = this.designer.formConfig.layoutType;
        if (!!val) {
          if (lyType === 'H5') {
            this.layoutProps.span = this.widget.options.xs || 12;
          } else if (lyType === 'Pad') {
            this.layoutProps.span = this.widget.options.sm || 12;
          } else {
            this.layoutProps.span = this.widget.options.md || 12;
          }
        } else {
          this.layoutProps.span = Number(this.widget.options.span) || 12;
        }
      }
    },
    'widget.options.span': {
      handler: function handler(val) {
        this.layoutProps.span = Number(val);
      }
    },
    'widget.options.md': {
      handler: function handler(val) {
        this.layoutProps.span = Number(val);
      }
    },
    'widget.options.sm': {
      handler: function handler(val) {
        this.layoutProps.span = Number(val);
      }
    },
    'widget.options.xs': {
      handler: function handler(val) {
        this.layoutProps.span = Number(val);
      }
    },
    'widget.options.offset': {
      handler: function handler(val) {
        this.layoutProps.offset = Number(val);
      }
    },
    'widget.options.push': {
      handler: function handler(val) {
        this.layoutProps.push = Number(val);
      }
    },
    'widget.options.pull': {
      handler: function handler(val) {
        this.layoutProps.pull = Number(val);
      }
    }
  },
  created: function created() {
    this.initRefList();
    this.initLayoutProps();
  },
  methods: {
    initLayoutProps: function initLayoutProps() {
      if (!!this.widget.options.responsive) {
        var lyType = this.designer.formConfig.layoutType;
        if (lyType === 'H5') {
          this.layoutProps.span = Number(this.widget.options.xs) || 12;
        } else if (lyType === 'Pad') {
          this.layoutProps.span = Number(this.widget.options.sm) || 12;
        } else {
          this.layoutProps.span = Number(this.widget.options.md) || 12;
        }
      } else {
        this.layoutProps.span = Number(this.widget.options.span);
      }
    },
    onGridDragEnd: function onGridDragEnd(evt, subList) {
      //
    },
    onGridDragAdd: function onGridDragAdd(evt, subList) {
      var newIndex = evt.newIndex;
      if (!!subList[newIndex]) {
        this.designer.setSelected(subList[newIndex]);
        this.designer.setNamesList(subList[newIndex]);
      }
      this.designer.emitHistoryChange();
      this.designer.emitEvent('field-selected', this.widget);
    },
    onGridDragUpdate: function onGridDragUpdate() {
      this.designer.emitHistoryChange();
    },
    selectWidget: function selectWidget(widget) {
      this.designer.setSelected(widget);
    },
    checkContainerMove: function checkContainerMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    selectParentWidget: function selectParentWidget() {
      if (this.parentWidget) {
        this.designer.setSelected(this.parentWidget);
      } else {
        this.designer.clearSelected();
      }
    },
    moveUpWidget: function moveUpWidget() {
      this.designer.moveUpWidget(this.parentList, this.indexOfParentList);
    },
    moveDownWidget: function moveDownWidget() {
      this.designer.moveDownWidget(this.parentList, this.indexOfParentList);
    },
    cloneGridCol: function cloneGridCol(widget) {
      this.designer.cloneGridCol(widget, this.parentWidget);
    } // removeWidget() {
    //   if (!!this.parentList) {
    //     let nextSelected = null
    //     if (this.parentList.length === 1) {
    //       if (!!this.parentWidget) {
    //         nextSelected = this.parentWidget
    //       }
    //     } else if (this.parentList.length === 1 + this.indexOfParentList) {
    //       nextSelected = this.parentList[this.indexOfParentList - 1]
    //     } else {
    //       nextSelected = this.parentList[this.indexOfParentList + 1]
    //     }
    //     this.$nextTick(() => {
    //       this.parentList.splice(this.indexOfParentList, 1)
    //       //if (!!nextSelected) {
    //       this.designer.setSelected(nextSelected)
    //       //}
    //       this.designer.emitHistoryChange()
    //     })
    //   }
    // }
  }
};